
import * as React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
} from 'react-admin';
import InstanceTitle from './InstanceTitle';

// const InstanceTitle = ({ record }) => {
//     return <span>Instance {record ? `"${record.name}"` : ''}</span>;
// };

const InstanceEdit = props => (
    <Edit title={<InstanceTitle />} {...props}>
        <SimpleForm>
            <TextInput source="name" />
            <TextInput source="slug" />
        </SimpleForm>
    </Edit>
);

export default InstanceEdit;